<template>
  <div class="dropdown--content--search">
    <Search v-model="query"/>
    
    <ul>
      <li
        v-for="(item, index) in computedList"
        v-bind:key="item.id"
        v-bind:data-index="index"
      >
        <a
          v-on:click="storeSelectedApplication(
            item.id,
            item.name
          )"
        >
          {{ item.name }}
        </a>
      </li>

      <li v-if="computedList.length === 0">No results found 😟</li>
    </ul>
  </div>
</template>

<script>  
  import { API } from '../../../services/api.ts'
  import Search from '../../form/search.vue'

  export default {
    name: 'DropdownSearch',
    props: [
      'list'
    ],
    components: {
      Search
    },
    data () {
      return {
        query: ''
      }
    },
    computed: {
      computedList: function() {
        let self = this

        return this.list.filter(function (item) {
          return item.name.toLowerCase().indexOf(self.query.toLowerCase()) !== -1
        })
      }
    },
    methods: {
      openDropDown: function(e) {
        let ulEl = e.target.nextElementSibling;
        let isCurrentDropdownShown = ulEl.classList.contains('dropdown--show');
        let dropdowns = document.getElementsByClassName('dropdown--list');

        let dropdownButtons = document.getElementsByClassName('dropdown--button');

        for (let i = 0; i < dropdowns.length; i++) {
          dropdowns[i].classList.remove('dropdown--show');
          dropdownButtons[i].classList.remove('dropdown--button-active');
        }

        if (!isCurrentDropdownShown){
          ulEl.classList.add('dropdown--show');
          e.target.classList.add('dropdown--button-active')
        }
      },
      storeSelectedApplication: function(id, name) {
        API.get(
        `index.cfm?act=applications.select&id=${id}`
        ).then(
          response => {
            localStorage.token = response.data.token
            localStorage.selectedApplicationId = id;
            localStorage.selectedApplicationName = name;

            location.reload();
          }
        )
      }
    },
    mounted() {
      console.log(this.list);
    }
  }
</script>

<style lang="scss">
  .dropdown--content--search {

    .search {
      margin-bottom: 5px;
    }

    &--title {
      font-weight: bold;
    }

    ul {
      max-height: 150px;
      overflow-y: scroll;

      li {
        padding: 5px 10px;

        a {
          
          &:hover {
            text-decoration: underline;
          }
        }
      }
    }
  }
</style>